import axios from 'axios'

export default ({ path, file }) => {
  return axios({
    url: `${path}/${file}`,
    method: 'GET',
    responseType: 'blob'
  })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', file)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    })
    .catch(error => {
      throw new Error(`Api Service GET can't download file ${file} at ${path} Failed: ${error}`)
    })
}
